import { Link as RouterLink } from 'react-router';

import type { LaunchDarklyAlert } from '@cfa/pathway-fe-shared/alerts';
import { Link } from '@cfa/react-components';

import { getNameFromLanguage } from '@/utils/language';

interface AlertLinkProps {
  link: NonNullable<LaunchDarklyAlert['link']>;
  language: string;
}

/**
 * Inline design-system link for LaunchDarkly message blocks. App paths
 * navigate in the SPA (via react-router); absolute http(s) URLs open in a new tab.
 */
const AlertLink = ({ link, language }: AlertLinkProps) => {
  const text = getNameFromLanguage(link.text, language);

  if (/^https?:\/\//i.test(link.url)) {
    return (
      <Link href={link.url} rel="noreferrer" target="_blank" variant="inline">
        {text}
      </Link>
    );
  }

  return (
    // Rendered as a router <Link> (still an <a>): the legacy Link turns into a
    // <button> without href when given onClick.
    <Link as={RouterLink} to={link.url} variant="inline">
      {text}
    </Link>
  );
};

export default AlertLink;
